<div class="time-priority-list">
  <div cdkDropList class="options-list" (cdkDropListDropped)="drop($event)">
    @for (option of options; track option) {
      <div class="options-list-dragable-element" cdkDrag>
        <div class="layout-element">
          <i class="fa-thin fa-grip-lines"></i>
          <sc-content-spacer></sc-content-spacer>
          {{'' | translateDictionaryEntry: [option.name, translationService.language]}}
        </div>
        <sc-list-spacer></sc-list-spacer>
      </div>
    }

  </div>

</div>